/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that 
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "url:../images/motion-background.jpg";

const imageAltText = "abstract flowing texture background";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "I engineer software systems that bridge user-facing products with AI capabilities. My focus is turning ideas into robust, measurable, and maintainable solutions.";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "Python and FastAPI",
  "Flutter",
  "LLM APIs and RAG",
  "NLP",
  "Design patterns and software architecture",
  "Vector databases",
  "Cloud deployment",
  "CI/CD workflows",
  "Prompt and eval design",
  "Performance optimization",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I care deeply about system clarity: predictable APIs and interfaces that make complex AI features feel simple for real users.";

const About = () => {
  return (
    <section className="padding about-section" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div className="about-panel">
        <h2>Engineering Mindset</h2>
        <p className="large">{description}</p>
        <hr />
        <ul className="skills-grid">
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p className="about-quote">{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
